"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ScrollToTop = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollToTop, _super);
    function ScrollToTop(props, context) {
        return _super.call(this, props, context) || this;
    }
    ScrollToTop.prototype.shouldComponentUpdate = function () {
        return window.scrollY !== 0 || window.scrollX !== 0;
    };
    ScrollToTop.prototype.componentDidUpdate = function () {
        window.scrollTo(0, 0);
    };
    ScrollToTop.prototype.render = function () {
        return null;
    };
    ScrollToTop.defaultProps = {};
    return ScrollToTop;
}(React.Component));
exports.default = ScrollToTop;
